(function (window, document, undefined) {
  "use strict";

  const testExp = new RegExp(
    "Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile",
    "i"
  );

  let mobile = false;

  function init() {
    if (testExp.test(navigator.userAgent)) {
      mobile = true;
    }

    attachEventHandlers();
  }

  function attachEventHandlers() {
    const buttons = document.querySelectorAll(
      ".vodl-share-button-bar__share:not([data-vodl-consent-required])"
    );

    Array.from(buttons).forEach(function (button) {
      const type = button.dataset.type;

      button.removeEventListener("click", eval(type));
      button.addEventListener("click", eval(type));
    });
  }

  // These functions are attached to the buttons click event handlers
  // based on the button data-type attribute.
  // That is why eslint will trigger an error here.
  /* eslint-disable no-unused-vars */
  const fb = function fbLink(e) {
    e.preventDefault();
    e.stopPropagation();

    const share = {
      method: "share",
      mobile_iframe: true,
      href: e.currentTarget.href,
    };

    window.FB.ui(share, function (response) {
      console.log(response);
    });
  };

  const messenger = function messengerLink(e) {
    e.preventDefault();
    e.stopPropagation();
    if (mobile) {
      const app_id = "141427045886945";
      window.open(
        "fb-messenger://share?link=" +
          encodeURIComponent(window.location.href) +
          "&app_id=" +
          encodeURIComponent(app_id)
      );
    } else {
      window.FB.ui({
        method: "send",
        link: e.currentTarget.href,
      });
    }
  };

  const twitter = function twitterLink(e) {
    e.stopPropagation();

    const shareUrl = e.currentTarget.href;

    console.log(shareUrl);

    window.open(shareUrl, "_blank", "width=500,height=400");
  };

  const whatsapp = function whatsappLink(e) {
    e.preventDefault();
    e.stopPropagation();

    console.log(e.currentTarget.href);

    if (mobile) {
      window.open("whatsapp://send?text=" + e.currentTarget.href, "_blank");
    } else {
      window.open(
        "https://web.whatsapp.com/send?text=" + e.currentTarget.href,
        "_blank",
        "width=500,height=400"
      );
    }
  };

  const gift = function giftLink(e) {
    e.preventDefault();
    e.stopPropagation();

    document.dispatchEvent(
      new CustomEvent("vodl_interaction_clicked", {
        detail: {
          interaction: {
            type: "gift",
          },
        },
      })
    );
  };
  /* eslint-enable no-unused-vars */

  $(document).ready(function () {
    init();

    document.addEventListener("newPage", init);
    document.addEventListener("refreshShareButtons", init);
  });
})(window, document);
